import {lang}             from "rapid/languages";

const defaultFormat = "YYYY-MM-DD[T]HH:mm:ss.SSS";

export function momentRun($rootScope, $auth) {
	"ngInject";
	let momentConfiguration = $rootScope.$on("$stateChangeStart", () => {
		if ($auth.isAuthenticated() && momentConfiguration) {
			window.moment.tz.setDefault($auth.getUser().timezone);
			window.moment.locale(lang());
			momentConfiguration = null;
		}
	});
	window.moment.defaultFormat = defaultFormat;
	window.moment.defaultFormatUtc = defaultFormat;
	window.moment.fn.toJSON = function () {
		return this.format(defaultFormat);
	};
}


// WEBPACK FOOTER //
// ./sources/bootstrap/moment.run.js